import script from "./DeclarationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DeclarationsSection.vue?vue&type=script&setup=true&lang=js"

import "./DeclarationsSection.vue?vue&type=style&index=0&id=7132db40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7132db40"]])

export default __exports__